import React from 'react';
import ScrollAnim from 'rc-scroll-anim';
import TweenOne from 'rc-tween-one';

const ScrollOverPack = (props) => {
  var { children, ...props } = props;
  const OverPack = ScrollAnim.OverPack;

  return (
    <OverPack {...props}>
        {children}
    </OverPack>
  );
};

ScrollOverPack.defaultProps = {
  always: false,
  playScale: 0.3
};

const FadeIn = {
  animation: {opacity: 1},
  style: {opacity: 0}
};

const FadeUp = {
  animation: {y: 0, opacity: 1},
  style: {transform: 'translateY(100px)', opacity: 0}
};

const FadeLeft = {
  animation: {x: 0, opacity: 1},
  style: {transform: 'translateX(100px)', opacity: 0}
};

const FadeRight = {
  animation: {x: 0, opacity: 1},
  style: {transform: 'translateX(-100px)', opacity: 0}
};

export default {
  ScrollOverPack,
  TweenOne,
  FadeIn,
  FadeUp,
  FadeLeft,
  FadeRight
};



// WEBPACK FOOTER //
// ./src/components/Animations.js